// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"BasketTitle_titleWrapper__A9LXv","controls":"BasketTitle_controls__1p0nH","label":"BasketTitle_label__mCINp"};